// Componente principal do conteúdo do Register
import React from "react";
import Area from "./area/area";
import DataBasic from "./data-basic/data-basic";
import Plague from "./plague/plague";
import CaterpillarPlague from "./caterpilar-plague/caterpilar-plague";
import BeetlePlague from "./beetle-plague/beetle-plague";
import PsilideoPlague from "./psilideo-plague/psilideo-plague";
import BracellPlantCountSelector from "./bracell/BracellPlantCountSelector";
import BracellCaterpillarPlague from "./bracell/BracellCaterpillarPlague";
import BracellBeetlePlague from "./bracell/BracellBeetlePlague";
import BracellPsilideoConcha from "./bracell/BracellPsilideoConcha";
import BracellPsilideoPercevejo from "./bracell/BracellPsilideoPercevejo";
import BracellLeptocybe from "./bracell/BracellLeptocybe";
import { isBracellEnterprise } from "../config/bracellRegistryProfile";
import {
  CATERPILLAR_PLAGUES,
  BEETLE_PLAGUES,
  PSILIDEO_PLAGUES,
  LEPTOCYBE_PLAGUES,
} from "../utils/constants";
import style from "../body-register.module.css";

/**
 * Componente RegisterContent - Conteúdo principal do Register
 */
const RegisterContent = ({
  informationPlague,
  containPlague,
  plot,
  auxValidator,
  bracellPlantCount,
  onBracellPlantCountChange,
  parcelas,
  onInformationArea,
  onInformationPlague,
  onInformationDataBasic,
  onInfestation,
  onDataForm,
  onSaveRegister,
}) => {
  const renderPlagueComponent = () => {
    if (
      !informationPlague ||
      typeof informationPlague !== "object" ||
      !informationPlague.name ||
      !informationPlague.scientific
    ) {
      return null;
    }

    const plagueName = informationPlague.name;
    const isBracell = isBracellEnterprise();
    const pc = bracellPlantCount;

    if (isBracell) {
      if (CATERPILLAR_PLAGUES.includes(plagueName)) {
        return (
          <BracellCaterpillarPlague
            plague={informationPlague}
            infestation={onInfestation}
            data={onDataForm}
            plantCount={pc}
            parcelas={parcelas}
          />
        );
      }
      if (BEETLE_PLAGUES.includes(plagueName)) {
        return (
          <BracellBeetlePlague
            plague={informationPlague}
            infestation={onInfestation}
            data={onDataForm}
            plantCount={pc}
            plot={plot}
            parcelas={parcelas}
          />
        );
      }
      if (plagueName === "Psilideo de Concha") {
        return (
          <BracellPsilideoConcha
            plague={informationPlague}
            infestation={onInfestation}
            data={onDataForm}
            plantCount={pc}
            parcelas={parcelas}
          />
        );
      }
      if (plagueName === "Percevejo Bronzeado") {
        return (
          <BracellPsilideoPercevejo
            plague={informationPlague}
            infestation={onInfestation}
            data={onDataForm}
            plantCount={pc}
            parcelas={parcelas}
          />
        );
      }
      if (LEPTOCYBE_PLAGUES.includes(plagueName)) {
        return (
          <BracellLeptocybe
            plague={informationPlague}
            infestation={onInfestation}
            data={onDataForm}
            plantCount={pc}
            parcelas={parcelas}
          />
        );
      }
      return null;
    }

    if (CATERPILLAR_PLAGUES.includes(plagueName)) {
      return (
        <CaterpillarPlague
          plague={informationPlague}
          infestation={onInfestation}
          data={onDataForm}
        />
      );
    }
    if (BEETLE_PLAGUES.includes(plagueName)) {
      return (
        <BeetlePlague
          plague={informationPlague}
          infestation={onInfestation}
          data={onDataForm}
        />
      );
    }
    if (PSILIDEO_PLAGUES.includes(plagueName)) {
      return (
        <PsilideoPlague
          plague={informationPlague}
          infestation={onInfestation}
          data={onDataForm}
        />
      );
    }

    return null;
  };

  const showBracellPlantSelector =
    isBracellEnterprise() &&
    containPlague &&
    informationPlague &&
    informationPlague.name;

  return (
    <div className={style["body-home"]}>
      <Area areaInformations={onInformationArea} validator={auxValidator} />

      <DataBasic plot={plot} parcelas={isBracellEnterprise() ? parcelas : undefined} />

      <Plague plagueSelect={onInformationPlague} validator={auxValidator} />

      {showBracellPlantSelector && (
        <BracellPlantCountSelector
          value={bracellPlantCount}
          onChange={onBracellPlantCountChange}
        />
      )}

      {renderPlagueComponent()}

      {containPlague && (
        <button className={style["button"]} onClick={onSaveRegister}>
          Enviar
        </button>
      )}
    </div>
  );
};

export default RegisterContent;
